import styles from './TextboxAlignLeft.module.css'
import Arrow from '../assets/arrowTopRight.jsx';
import CMSLink from './common/CMSLink.jsx';


function TextboxAlignLeft({ title,
    content,
    textboxButtonText,
    buttonLink,
    buttonColor,
    buttonTextColor }) {


    return (
        <section>


            <div className={`${styles.textbox} ${styles.alignLeft}`}>
                <h2 className={styles.title}>{title}</h2>
                {/* I'm assuming that this field would be richtext so we can add that after getting that set up in Contentful*/}
                <div className={styles.content}>
                    <p>{content}</p>

                </div>
                {textboxButtonText && buttonLink && (
                    <div className="cell">
                        <CMSLink path={buttonLink}>
                            <div className={`ctaBox ${styles.button}`} style={{ background: buttonColor, color: buttonTextColor }}>
                                <div className="contents">
                                    {textboxButtonText} <Arrow />
                                </div>
                            </div>
                        </CMSLink>
                    </div>
                )}
            </div>
        </section>
    );
}

export default TextboxAlignLeft;